import { CapacityMonitoring, ResearchDepartment } from '@features/client/models/capacity-monitoring.model';
import { CostAvoidance } from '@features/client/models/cost-avoidance.model';
import { Overview } from '@features/client/models/overview.model';
import { CapacityMonitoringReportBase, ResearchReport, SavedReport } from '@features/client/models/reports.model';
import { BaseRequestData, CapacityMonitoringData } from '@features/client/models/request-data.model';
import { DateRangeModel } from '@shared/models/date-range.model';

import { HttpResponse } from '@angular/common/http';
import { ResearchDetails } from '@features/client/models/research.model';
import { Optimization } from '@features/client/models/workspace-optimization.model';
import { createAction, props } from '@ngrx/store';

export const getOverview = createAction('[Overview] get overview', props<{ requestData?: BaseRequestData }>());
export const getOverviewSuccess = createAction('[Overview] get overview success', props<{ overview: Overview }>());
export const getOverviewFailure = createAction('[Overview] get overview failure');
export const getCapacityMonitoring = createAction(
  '[CapacityMonitoringModel] get capacity monitoring',
  props<{ requestData?: CapacityMonitoringData }>()
);
export const getCapacityMonitoringSuccess = createAction(
  '[CapacityMonitoringModel] get capacity monitoring success',
  props<{ capacityMonitoring: CapacityMonitoring }>()
);
export const getCapacityMonitoringFailure = createAction('[CapacityMonitoringModel] get capacity monitoring failure');
export const getCapacityMonitoringPdfTemplate = createAction(
  '[CapacityMonitoringPdf] get capacity monitoring for pdf template',
  props<{ requestData?: CapacityMonitoringData; reportName: string }>()
);
export const getCapacityMonitoringPdfTemplateSuccess = createAction(
  '[CapacityMonitoringPdf] get capacity monitoring for pdf template success',
  props<{ capacityMonitoring: CapacityMonitoring; reportName: string }>()
);
export const getCapacityMonitoringPdfTemplateFailure = createAction(
  '[CapacityMonitoringPdf] get capacity monitoring for pdf template failure',
  props<{ reportName: string }>()
);
export const clearCapacityMonitoringPdfTemplateData = createAction(
  '[CapacityMonitoringPdf] clear CapacityMonitoringPdfTemplate'
);
export const getResearchDepartments = createAction('[ResearchDepartments] get research departments');
export const getResearchDepartmentsSuccess = createAction(
  '[ResearchDepartments] get research departments success',
  props<{ departments: ResearchDepartment[] }>()
);
export const getResearchDepartmentsFailure = createAction('[ResearchDepartments] get research departments failure');

export const clearResearchDepartments = createAction('[ResearchDepartments] clear research departments');
export const setResearchId = createAction('[ClientResearch] set research id', props<{ researchId: number }>());
export const clearOverviewData = createAction('[Overview] clear overview');
export const clearCapacityMonitoringData = createAction('[Capacity Monitoring] clear capacity monitoring');
export const getSavedReports = createAction('[Reports] get saved reports');
export const getSavedReportsSuccess = createAction(
  '[Reports] get saved reports success',
  props<{ reports: SavedReport[] }>()
);
export const getSavedReportsFailure = createAction('[Reports] get saved reports failure');

export const getResearchReports = createAction('[Reports] get research reports');
export const getResearchReportsSuccess = createAction(
  '[Reports] get research reports success',
  props<{ researchReports: ResearchReport[] }>()
);
export const getResearchReportsFailure = createAction('[Reports] get research reports failure');

export const getResearchReportFile = createAction(
  '[Reports] get research report file',
  props<{ reportId: number; reportName: string }>()
);
export const getResearchReportFileSuccess = createAction(
  '[Reports] get research report file success',
  props<{ researchReportFileUrl: string; researchReportFileName: string }>()
);
export const getResearchReportFileFailure = createAction('[Reports] get research report file failure');

export const getCostAvoidance = createAction('[CostAvoidance] get cost avoidance');
export const getCostAvoidanceSuccess = createAction(
  '[CostAvoidance] get cost avoidance success',
  props<{ costAvoidance: CostAvoidance }>()
);
export const getCostAvoidanceFailure = createAction('[CostAvoidance] get cost avoidance failure');

export const deleteReport = createAction('[Reports] delete report', props<{ reportId: number }>());
export const deleteReportSuccess = createAction('[Reports] delete report success', props<{ reportId: number }>());
export const deleteReportFailure = createAction('[Reports] delete report failure');

export const saveCapacityMonitoringAsReport = createAction(
  '[Capacity Monitoring] save capacity monitoring as report',
  props<{ reportData: CapacityMonitoringReportBase }>()
);
export const saveCapacityMonitoringAsReportSuccess = createAction(
  '[Capacity Monitoring] save capacity monitoring as report success',
  props<{ researchId: number; reportId: number }>()
);
export const saveCapacityMonitoringAsReportFailure = createAction(
  '[Capacity Monitoring] save capacity monitoring as report failure'
);

export const getWorkspaceOptimization = createAction('[WorkspaceOptimization] get workspace optimization');
export const getWorkspaceOptimizationSuccess = createAction(
  '[WorkspaceOptimization] get workspace optimization success',
  props<{ optimization: Optimization }>()
);
export const getWorkspaceOptimizationFailure = createAction(
  '[WorkspaceOptimization] get workspace optimization failure'
);

export const updateReport = createAction(
  '[Reports] update report',
  props<{ report: SavedReport | CapacityMonitoringReportBase; reportId: number }>()
);
export const updateReportSuccess = createAction('[Reports] update report success', props<{ report: SavedReport }>());
export const updateReportFailure = createAction('[Reports] update report failure');

export const downloadExcelAnalyticalData = createAction(
  '[Capacity Monitoring] download excel analytical data',
  props<{ dateRange: DateRangeModel; departmentId?: number }>()
);
export const downloadExcelAnalyticalDataSuccess = createAction(
  '[Capacity Monitoring] download excel analytical data success',
  props<{ analyticalDataResponse: HttpResponse<string>; fileName: string }>()
);
export const downloadExcelAnalyticalDataFailure = createAction(
  '[Capacity Monitoring] download excel analytical data failure',
  props<{ fileName: string }>()
);

export const getResearchDetailsSuccess = createAction(
  '[Research Status] get research details success',
  props<{ researchDetails: ResearchDetails; researchId: number }>()
);
export const getResearchDetailsFailure = createAction('[Research Status] get research details failure');
